import type { FileItem } from "@titancloud/shared";
import { formatBytes } from "../../utils/formatBytes";
import { formatAbsoluteDate } from "../../utils/dateFormat";

interface PreviewFileInfoProps {
  file: FileItem;
  onClose: () => void;
}

function InfoRow({ label, value }: { label: string; value: string }) {
  return (
    <div className="flex items-start justify-between gap-4 py-1.5">
      <span className="flex-shrink-0 text-xs text-gray-500">{label}</span>
      <span className="break-all text-right text-xs text-gray-200">{value}</span>
    </div>
  );
}

/** File-details popover shown from the info button in the preview header. */
export function PreviewFileInfo({ file, onClose }: PreviewFileInfoProps) {
  return (
    <>
      {/* Click-outside catcher — starts below the header so the close/info
          buttons up there stay clickable while this is open */}
      <div className="fixed inset-x-0 bottom-0 top-14 z-20" onClick={onClose} />

      <div
        className="absolute left-4 top-14 z-30 w-72 rounded-xl border border-white/10 bg-gray-900 p-4 shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        <h3 className="mb-1 text-sm font-semibold text-gray-100">File details</h3>
        <div className="divide-y divide-white/5">
          <InfoRow label="Name" value={file.name} />
          <InfoRow label="Type" value={file.mimeType} />
          <InfoRow label="Size" value={formatBytes(file.sizeBytes)} />
          <InfoRow label="Uploaded" value={formatAbsoluteDate(file.createdAt)} />
          {file.updatedAt !== file.createdAt && (
            <InfoRow label="Modified" value={formatAbsoluteDate(file.updatedAt)} />
          )}
        </div>
      </div>
    </>
  );
}
